import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navLinks } from "@/mocks/site";
import SearchBar from "./SearchBar";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-gradient-to-b from-background-50/95 to-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-xl"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950 whitespace-nowrap">
            榴莲<span className="text-accent-500">视频</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 ml-4">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "text-accent-500 font-medium"
                    : "text-foreground-500 hover:text-foreground-950 hover:bg-background-100/70"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block ml-auto w-[280px]">
          <SearchBar variant="navbar" />
        </div>

        <div className="ml-auto flex items-center gap-2 lg:ml-3">
          <Link
            to="/search"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-500 hover:text-foreground-950 hover:bg-background-100 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl"></i>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-950 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/98 backdrop-blur-md animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            <SearchBar
              variant="navbar"
              placeholder="搜索影视或资讯..."
            />
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-lg px-4 py-3 text-base transition-colors ${
                      isActive
                        ? "bg-primary-500/15 text-accent-500 font-medium"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}